module.exports = __webpack_public_path__ + "static/media/whatsappBg.db137940.png";